import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackRemoveReminderFromWishListParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/wishList/trackRemoveReminderFromWishList";

const useTrackRemoveReminderFromWishList = (
    parameters: TrackRemoveReminderFromWishListParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.removeReminderFromWishList, parameters, options);
};

export default useTrackRemoveReminderFromWishList;
